module.exports = __webpack_public_path__ + "static/media/user.c9fffa0e.svg";